var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBnbxLight = function SvgBnbxLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12Zm-6.858 9.385 4.243-4.243-2.018-2.018a8.028 8.028 0 0 1-4.243 4.243l2.018 2.018Zm-7.71-1.806a8.025 8.025 0 0 1-4.554-3.93l-1.635 1.635 4.242 4.243 1.948-1.948ZM6.634 10.876a8.028 8.028 0 0 1 4.243-4.243L9.243 5 5 9.243l1.633 1.633Zm11.015-3.998 1.737-1.736 4.242 4.243-2.048 2.048a8.025 8.025 0 0 0-3.93-4.555Z",
    fill: "#060710"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.992 9.838 14.162 8l3.17 1.838-1.166.68-2.004-1.16-2.004 1.16-1.165-.68Zm6.34 2.318-1.166-.679-2.004 1.16-2.004-1.16-1.165.68v1.357l2.004 1.16v2.317l1.165.68 1.165-.68v-2.318l2.004-1.159v-1.358Zm0 3.676v-1.358l-1.166.68v1.357l1.165-.679Zm.826.48-2.004 1.16v1.357l3.17-1.838v-3.676l-1.166.68v2.317Zm-1.165-5.315 1.165.68v1.357l1.165-.679v-1.358l-1.165-.679-1.165.68Zm-3.996 6.966v1.358l1.165.679 1.165-.679v-1.358l-1.165.679-1.165-.68Zm-2.005-2.13 1.166.678v-1.358l-1.165-.679v1.358Zm2.005-4.836 1.165.68 1.165-.68-1.165-.679-1.165.68Zm-2.832.68 1.165-.68-1.165-.679-1.165.68v1.357l1.165.68v-1.359Zm0 2.317L9 13.315v3.676l3.17 1.838v-1.358l-2.005-1.159v-2.318Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 1.4,
    width: 25.2,
    height: 25.2,
    rx: 12.6,
    stroke: "#fff",
    strokeWidth: 1.2
  })));
};
export default SvgBnbxLight;